import React from "react";

function About() {
  return <div>The page you requested doesnt exist.</div>;
}

export default About;
